import React, { useEffect } from "react"
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom"
import { useApp } from "./AppProvider"
import { ROLES } from "./sections/sidebar/constants"
import MiniDrawer from "./sections/sidebar"
import Login from "./sections/login"
import RecoverPassword from "./sections/recoverPassword"
import ChangePassword from "./sections/changePassword"
import { ROUTES } from "./routers/constants"
import CreatePassword from "./sections/createPassword"
import NotificationSnackbar from "./components/notification-snackbar"
import RatesLanding from "./sections/landingExtension/RatesLanding"
import { SECTIONS } from "./sections/sidebar/constants"
import { getUserBusinessRates } from "./sections/ratesCalculator/services/api"
import { checkCampaignPending } from "./sections/tickets/services/api"

const Redirect1 = () => {
  const { currentUser } = useApp()
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    if (currentUser) {
      if (currentUser.role === ROLES.CLIENT || currentUser.role === ROLES.EXT || currentUser.role === ROLES.BUSINESS_ADMIN) {
        navigate("/dashboard")
      } else {
        navigate("/tickets")
      }
    } else {
      navigate("/login")
    }
  }, [])
  return null
}

const Redirect2 = () => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate("/")
  }, [])
  return null
}

const AppRouter = () => {
  const {
    currentUser,
    shouldShowNotification,
    hideNotification,
    notificationMessage,
    notificationSeverity,
    notificationOrigin,
    notificationMargin,
  } = useApp()

  const [sections, setSections] = React.useState(
    SECTIONS.filter((section) => section.link != "rates-contact")
  )

  const fetchRates = React.useCallback(async (sec) => {
    try {
      const response = await getUserBusinessRates()
      const data = response.data
      if (data.length != 0) {
        const auxSections = SECTIONS.filter(
          (section) => section.link == "rates-contact"
        )
        sec.push(auxSections[0])
        setSections(sec)
      } else if (window.location.pathname == "/rates-contact") {
        window.location.href = "/home"
      }
    } catch (e) {
      console.log(e)
    }
  })

  useEffect(() => {
    if (currentUser) {
      const newSections = sections
        .map((section) => {
          if (section.roles.includes(currentUser.role)) {
            return section
          }
        })
        .filter(Boolean)
      if (currentUser.role === ROLES.CLIENT || currentUser.role === ROLES.BUSINESS_ADMIN) {
        fetchRates(newSections)
        if (currentUser.role === ROLES.BUSINESS_ADMIN){
          setInterval(checkAlert, 5000)
        }
      } else {
        setInterval(checkAlert, 5000)
        setSections(newSections)
      }
    } else {
      setSections(SECTIONS.filter((section) => section.link != "rates-contact"))
    }
  }, [currentUser])

  const fetchPendingTickets = React.useCallback(async () => {
    try {
      const response = await checkCampaignPending(
        new Date().toISOString().split("T")[0]
      )
      const data = response.data
      SECTIONS.forEach((section) => {
        if (section.link == "tickets") {
          section.alert = data
        }
      })
      setSections(SECTIONS)
    } catch (e) {
      console.log(e)
    }
  })

  const checkAlert = () => {
    if (currentUser.role === ROLES.SUPER || currentUser.role === ROLES.ADMIN || currentUser.role === ROLES.BUSINESS_ADMIN) {
      fetchPendingTickets()
    }
  }

  useEffect(() => {
    if (currentUser) {
      checkAlert()
    }
  }, [currentUser, location.pathname])

  return (
    <BrowserRouter>
      <NotificationSnackbar
        open={shouldShowNotification}
        setOpen={(open) => hideNotification()}
        message={notificationMessage}
        type={notificationSeverity}
        asOrigin={notificationOrigin}
        asMargin={notificationMargin}
      />
      <Routes>
        <Route exact path="/rates-landing" element={<RatesLanding />} />

        <Route exact path="/login" element={<Login />} />
        <Route path="/recover-password" element={<RecoverPassword />} exact />
        <Route path="/change-password" element={<ChangePassword />} exact />
        <Route path="/create-password" element={<CreatePassword />} exact />
        <Route element={<MiniDrawer user={currentUser} SECTIONS={sections} />}>
          {currentUser && ROUTES[currentUser.role]}
        </Route>
        <Route exact path="/" element={<Redirect1 />} />
        <Route path="*" element={<Redirect2 />}></Route>
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter
